import { Routes, Route, Navigate } from "react-router";
import App from "./App";
import Assistant from "./components/assistant/Assistant";
import Users from "./pages/Users";
import Responses from "./pages/Responses";
import Documents from "./pages/Documents";
import Settings from "./pages/Settings";
import RootRedirect from "./components/RootRedirect";
import RoleRestrictedRoute from "./roleRestrictedRoute";
import { appConfig } from "./appConfig";
import Analytics from "./pages/Analytics";

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<App />}>
        <Route
          index
          element={
            <RoleRestrictedRoute allowedRoles={["member", "admin", "superadmin"]}>
              <RootRedirect />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="assistant"
          element={
            <RoleRestrictedRoute allowedRoles={["member", "admin", "superadmin"]}>
              <Assistant key={window.location.search} />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="documents"
          element={
            <RoleRestrictedRoute allowedRoles={["admin", "superadmin"]}>
              <Documents />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="users"
          element={
            <RoleRestrictedRoute allowedRoles={["admin", "superadmin"]}>
              <Users />
            </RoleRestrictedRoute>
          }
        />
        {appConfig.features.analyticsDashboard && (
          <Route
            path="analytics"
            element={
              <RoleRestrictedRoute allowedRoles={["admin", "superadmin"]}>
                <Analytics />
              </RoleRestrictedRoute>
            }
          />
        )}
        <Route
          path="answers"
          element={
            <RoleRestrictedRoute allowedRoles={["admin", "superadmin"]}>
              <Responses />
            </RoleRestrictedRoute>
          }
        />
        <Route
          path="settings"
          element={
            <RoleRestrictedRoute allowedRoles={["admin", "superadmin"]}>
              <Settings />
            </RoleRestrictedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};

export default Router;
